<flat-header
  *ngIf="configurationService.isTabletOrLarger$ | async"
  headerText="saleModule.yourOrder"
></flat-header>
<div class="container-lg main-container bg-lg-transparent shadow-none">
  <div class="row">
    <div class="col-12 col-md-6 col-lg-7 mb-3 px-0 px-md-3">
      <section
        class="card"
        aria-labelledby="sale-checkout-order-summary-heading"
      >
        <ng-container *ngIf="sale">
          <div
            class="card-header text-end"
            *ngIf="sale.statusCode !== StatusCode.INFLIGHT"
          >
            <p class="mb-0 d-inline">{{ 'general.status' | translate }}:</p>
            <span
              class="badge ms-2"
              data-test-id="sale-checkout-sale-status"
              [ngClass]="{
                'bg-success': (sale | saleFinalStatusCode) === StatusCode.DONE,
                'bg-soft-primary': [
                  StatusCode.INFLIGHT,
                  StatusCode.PENDING_REQUIRED
                ].includes(sale | saleFinalStatusCode),
                'bg-soft-secondary':
                  (sale | saleFinalStatusCode) === StatusCode.CANCELLED
              }"
            >
              {{
                'saleModule.statusCode' + (sale | saleFinalStatusCode)
                  | translate
              }}
            </span>
          </div>
        </ng-container>
        <h2 id="sale-checkout-order-summary-heading" class="visually-hidden">
          {{ 'saleModule.yourOrder' | translate }}
        </h2>
        <div class="card-body">
          <sale-item-table-card
            *ngIf="sale"
            [hidden]="isLoading"
            [sale]="sale"
            [saleItems$]="saleItems$"
          ></sale-item-table-card>

          <!-- Amount already paid, due later amount and due now amount -->
          <table
            class="table d-flex flex-column d-md-table"
            *ngIf="sale?.statusCode !== StatusCode.CANCELLED"
          >
            <tfoot class="bg-light">
              <tr class="d-flex d-md-table-row" *ngIf="amountAlreadyPaid > 0">
                <td colspan="2" class="col-6 fw-bold text-body">{{
                  'saleModule.amountPaid' | translate
                }}</td>
                <td class="text-end col fw-bold text-body">
                  <span
                    class="text-nowrap"
                    data-test-id="sale-amount-already-paid"
                    >{{ amountAlreadyPaid | currency }}</span
                  >
                </td>
              </tr>

              <tr class="d-flex d-md-table-row" *ngIf="dueLaterAmount > 0">
                <td colspan="2" class="col-6 fw-bold text-body">{{
                  'saleModule.dueLaterAmount' | translate
                }}</td>
                <td class="text-end col fw-bold text-body">
                  <span
                    class="text-nowrap"
                    data-test-id="sale-amount-due-later-amount"
                    >{{ dueLaterAmount | currency }}</span
                  >
                </td>
              </tr>

              <tr
                class="d-flex d-md-table-row"
                *ngIf="sale && dueNowAmount && dueNowAmount !== sale.total"
              >
                <td colspan="2" class="col-6 fw-bold text-body">{{
                  'saleModule.dueNow' | translate
                }}</td>
                <td class="text-end col fw-bold text-body">
                  <span
                    class="text-nowrap"
                    data-test-id="sale-amount-due-now"
                    >{{ dueNowAmount | currency }}</span
                  >
                </td>
              </tr>
            </tfoot>
          </table>

          <div
            class="spinner-border"
            role="status"
            *ngIf="isLoading"
            attr.aria-label="{{ 'wcag.loading' | translate }}"
          >
          </div>
        </div>
      </section>
    </div>

    <div
      class="col-12 col-md-6 col-lg-5 px-0 px-md-3"
      *ngIf="sale?.statusCode != StatusCode.DONE && +sale?.total >= 0"
    >
      <section class="card">
        <div class="card-header">
          <h2 class="mb-0 h3">{{
            'paymentModule.paymentMethod' | translate
          }}</h2>
        </div>

        <div
          class="card-body"
          *ngIf="sale?.statusCode !== StatusCode.CANCELLED"
        >
          <p *ngIf="sale?.statusCode === StatusCode.INFLIGHT">
            {{ pendingSaleSecondsRemaining$ | async | secondsToReadable }}
            {{ 'saleModule.minutesRemainingToPay' | translate }}
          </p>
          <p *ngIf="sale?.statusCode === StatusCode.PENDING_REQUIRED">
            {{ 'saleModule.completePendingRequiredSale' | translate }}
          </p>
          <div *ngIf="sale?.statusCode === StatusCode.INFLIGHT">
            <progressbar
              [animate]="true"
              [value]="pendingSaleSecondsRemaining$ | async"
              [max]="2700"
              [striped]="true"
              type="danger"
              class="mb-3"
            >
            </progressbar>
          </div>

          <div class="mt-3" *ngIf="organization">
            <h3 class="h4">
              {{ 'organizationModule.organization' | translate }}
            </h3>
            <div>
              {{ 'saleModule.orderOnBehalfOf' | translate }}
              <strong>
                {{ organization?.description }}
              </strong>
            </div>
          </div>

          <div class="mt-3 mb-2" data-test-id="sale-checkout-loaded">
            <!-- start allow psp selection for dev and e2e purposes -->

            <fieldset>
              <legend class="visually-hidden">{{
                'saleModule.payMethod' | translate
              }}</legend>
              <div class="mt-1 mb-3">
                <select
                  *ngIf="paymentProvidersSettings.length > 1"
                  class="form-select"
                  (change)="onSetSelectedPaymentProviderType($event)"
                  attr.aria-label="{{
                    'paymentModule.paymentMethod' | translate
                  }}"
                  data-test-id="payment-provider-type-dropdown"
                >
                  <option
                    *ngFor="let paymentProvider of paymentProvidersSettings"
                    [value]="paymentProvider.name"
                    [selected]="
                      selectedPaymentProviderType === paymentProvider.name
                    "
                  >
                    {{ PaymentProviderType[paymentProvider.name] }}
                  </option>
                </select>
              </div>
              <!-- end allow psp selection for dev and e2e purposes -->

              <div
                *ngIf="
                  checkoutStage === 'unstarted' &&
                  (!shouldCreateStoredPayMethod ||
                    isStoredPayMethodCreationSideEffectOfPayment)
                "
              >
                <!-- Stored paymethods -->

                <div
                  *ngFor="let storedPayMethod of selectableStoredPayMethods"
                  class="mb-2 d-flex flex-row-reverse gap-2 p-3 rounded payment-method border"
                  data-test-id="sale-stored-pay-methods-card"
                >
                  <input
                    type="radio"
                    [disabled]="isStoredPayMethodExpired(storedPayMethod)"
                    name="selectedCheckoutPayMethod"
                    [id]="'radioStoredPayMethod' + storedPayMethod.id"
                    class="form-check-input p-2"
                    [ngClass]="{
                      'd-none': isStoredPayMethodExpired(storedPayMethod)
                    }"
                    (change)="onSelectStoredPayMethod(storedPayMethod)"
                    [checked]="selectedStoredPayMethodId === storedPayMethod.id"
                  />
                  <i
                    *ngIf="isStoredPayMethodExpired(storedPayMethod)"
                    class="fa fa-exclamation-triangle lead text-warning"
                    role="img"
                    aria-hidden="true"
                  ></i>

                  <label
                    class="payment-label flex-grow-1 form-check-label"
                    [for]="'radioStoredPayMethod' + storedPayMethod.id"
                    data-test-id="sale-checkout-stored-pay-method-row"
                  >
                    <div class="row gx-2">
                      <div class="col-2 text-center">
                        <img
                          [src]="getStoredPayMethodIcon(storedPayMethod)"
                          class="me-2"
                          alt="{{ 'saleModule.payMethod' | translate }}"
                          aria-hidden="true"
                        />
                      </div>
                      <div class="col-10">
                        <div class="text-black fw-bold">
                          {{ storedPayMethod.description }}
                        </div>
                        <span
                          class="small"
                          *ngIf="isStoredPayMethodExpired(storedPayMethod)"
                          >{{ 'general.expired' | translate }}</span
                        >
                      </div>
                    </div>
                  </label>
                </div>

                <!-- Redirect to psp / add new paymethod / previous pay online -->
                <div
                  class="mb-2 d-flex flex-row-reverse gap-2 p-3 rounded payment-method border align-items-center cursor-pointer"
                  *ngIf="
                    isPaymentMethodSelectable(
                      PayMethodType.PAY_METHOD_CREDIT_CARD
                    )
                  "
                >
                  <input
                    data-test-id="sale-select-paymethod"
                    type="radio"
                    name="selectedCheckoutPayMethod"
                    id="radioOnline"
                    class="form-check-input p-2"
                    [checked]="
                      isPaymentMethodSelected(
                        PayMethodType.PAY_METHOD_CREDIT_CARD
                      )
                    "
                    (change)="
                      onSelectPaymentMethod(
                        PayMethodType.PAY_METHOD_CREDIT_CARD
                      )
                    "
                  />

                  <!-- Main Label for the Radio Button -->
                  <label
                    class="form-check-label payment-label flex-grow-1"
                    for="radioOnline"
                    data-test-id="sale-select-creditcard-paymethod"
                  >
                    <div class="mb-2 text-black fw-bold">
                      {{ newPayMethodOrPayOnlineTranslationString | translate }}
                    </div>

                    <div
                      class="d-flex flex-wrap gap-2"
                      *ngIf="
                        checkoutPaymentBrandIcons$ | async as paymentBrandIcons
                      "
                    >
                      <img
                        *ngFor="let paymentBrandIcon of paymentBrandIcons"
                        [src]="paymentBrandIcon.path"
                        [alt]="paymentBrandIcon.alt"
                        [width]="paymentBrandIcon.width"
                      />
                    </div>
                  </label>
                </div>

                <!-- INVOICE -->
                <div
                  *ngIf="
                    isPaymentMethodSelectable(PayMethodType.PAY_METHOD_INVOICE)
                  "
                  class="mb-2 d-flex flex-row-reverse gap-2 p-3 rounded payment-method border align-items-center"
                >
                  <input
                    aria-labelledby="radioInvoiceId"
                    type="radio"
                    name="selectedCheckoutPayMethod"
                    id="radioInvoice"
                    class="form-check-input p-2"
                    [checked]="
                      isPaymentMethodSelected(PayMethodType.PAY_METHOD_INVOICE)
                    "
                    (change)="
                      onSelectPaymentMethod(PayMethodType.PAY_METHOD_INVOICE)
                    "
                  />
                  <label
                    id="radioInvoiceId"
                    class="form-check-label payment-label flex-grow-1"
                    data-test-id="sale-select-invoice-paymethod"
                    for="radioInvoice"
                  >
                    <div class="row gx-2 align-items-center">
                      <div class="col-2 text-center">
                        <i
                          class="fas fa-file-invoice fa-fw lead"
                          aria-hidden="true"
                          role="img"
                        ></i>
                      </div>
                      <div class="col-10">
                        <div class="mb-1 text-black fw-bold">
                          {{
                            'paymentModule.payMethodInvoiceTitle' | translate
                          }}
                        </div>
                        <div class="small">
                          {{
                            'paymentModule.payMethodInvoiceSubtext' | translate
                          }}
                        </div>
                        <div
                          *ngIf="
                            (prePaymentFactor$ | async) > 0 &&
                            (prePaymentFactor$ | async) < 1
                          "
                          class="small"
                        >
                          {{
                            'paymentModule.prePaymentInvoiceText'
                              | translate
                              | replaceVarInString
                                : '$PERCENTAGE$'
                                : getPrepaymentFactor(prePaymentFactor$ | async)
                          }}
                        </div>
                      </div>
                    </div>
                  </label>
                </div>

                <!-- BALANCE -->
                <div
                  *ngIf="
                    isPaymentMethodSelectable(
                      PayMethodType.PAY_METHOD_ACCOUNT
                    ) && member?.balance
                  "
                  class="mb-2 d-flex flex-row-reverse gap-2 p-3 align-items-center rounded border payment-method border"
                >
                  <input
                    aria-labelledby="radioAcount"
                    type="radio"
                    name="selectedCheckoutPayMethod"
                    id="radioAccount"
                    class="form-check-input p-2"
                    [checked]="
                      isPaymentMethodSelected(PayMethodType.PAY_METHOD_ACCOUNT)
                    "
                    (change)="
                      onSelectPaymentMethod(PayMethodType.PAY_METHOD_ACCOUNT)
                    "
                  />
                  <label
                    id="radioAccountId"
                    class="form-check-label payment-label flex-grow-1"
                    data-test-id="sale-select-balance-paymethod"
                    for="radioAccount"
                  >
                    <div class="row gx-2 align-items-center">
                      <div class="col-2 text-center">
                        <i
                          class="fas fa-wallet fa-fw lead"
                          aria-hidden="true"
                          role="img"
                        ></i>
                      </div>
                      <div class="col-10">
                        <div class="mb-1 text-black fw-bold">
                          {{ 'paymentModule.balance' | translate }}
                        </div>
                        <div class="small">
                          {{ 'paymentModule.useBalanceOf' | translate }}
                          <strong
                            data-test-id="sale-checkout-current-member-balance-amount"
                            >{{ member?.balance | currency }}</strong
                          >

                          <span
                            *ngIf="balanceWouldBePartialPayment()"
                            data-test-id="sale-checkout-current-member-balance-is-partial-payment"
                          >
                            {{ 'paymentModule.toPayPartly' | translate }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <!-- stored paymethod creation checkbox for psps where stored paymethod is created as side effect part of the sale, not legacy direct debit or worldline -->
              <ng-container
                *ngIf="isStoredPayMethodCreationSideEffectOfPayment"
              >
                <div class="form-check mt-3">
                  <input
                    id="user-wants-to-save-stored-pay-method"
                    type="checkbox"
                    data-test-id="user-wants-to-save-stored-pay-method"
                    class="form-check-input p-2"
                    [checked]="
                      userWantsToSaveStoredPayMethod ||
                      shouldCreateStoredPayMethod
                    "
                    [disabled]="shouldCreateStoredPayMethod"
                    [(ngModel)]="userWantsToSaveStoredPayMethod"
                  />
                  <label
                    class="form-check-label"
                    for="user-wants-to-save-stored-pay-method"
                  >
                    {{
                      'storedPayMethodModule.saveAsStoredPaymethod' | translate
                    }}
                  </label>
                </div>
              </ng-container>

              <!-- stored paymethod creation for legacy direct debit and worldline where user must create stored paymethod before doing a payment -->
              <ng-container
                *ngIf="
                  shouldCreateStoredPayMethod &&
                  !isStoredPayMethodCreationSideEffectOfPayment
                "
              >
                <div
                  class="mb-2 d-flex gap-2 p-3 rounded payment-method border"
                  data-test-id="sale-checkout-create-stored-paymethod"
                >
                  <div class="col">
                    <div class="mb-2 text-black fw-bold">
                      {{ 'storedPayMethodModule.storedPayMethod' | translate }}
                    </div>
                    <div class="mb-2 small">{{
                      'storedPayMethodModule.createStoredPayMethodSubText'
                        | translate
                    }}</div>
                  </div>

                  <div class="col-auto">
                    <button
                      type="button"
                      class="btn btn-soft-primary"
                      (click)="onClickCreateStoredPayMethod()"
                      data-test-id="sale-checkout-create-stored-paymethod-button"
                    >
                      {{ 'general.create' | translate }}
                    </button>
                  </div>
                </div>
              </ng-container>

              <!-- Apply gift card to sale -->
              <div class="my-3 row gx-2" *ngIf="showGiftCardSection">
                <div class="mb-2"
                  >{{ 'general.doYouHave' | translate }}
                  <a
                    role="button"
                    href="javascript:;"
                    data-test-id="sale-checkout-open-giftcard-form-button"
                    (click)="giftCardFormIsVisible = !giftCardFormIsVisible"
                    aria-controls="gift-card-form"
                    >{{ 'giftCardModule.giftCard' | translate }}</a
                  >?
                </div>

                <div
                  *ngIf="
                    giftCardFormIsVisible &&
                    giftCardRequiresStoredPayMethodSetup()
                  "
                  class="mb-3"
                >
                  <p>{{
                    'storedPayMethodModule.createStoredPayMethodSubText'
                      | translate
                  }}</p>
                  <button
                    type="button"
                    class="btn btn-soft-primary"
                    (click)="onClickCreateGiftCardStoredPayMethod()"
                    data-test-id="gift-card-create-stored-paymethod-button"
                    [disabled]="isLoading"
                  >
                    {{ 'general.create' | translate }}
                  </button>
                </div>

                <div
                  *ngIf="
                    giftCardFormIsVisible &&
                    !giftCardRequiresStoredPayMethodSetup()
                  "
                  id="gift-card-form"
                >
                  <div class="input-group">
                    <input
                      attr.aria-label="{{ 'wcag.giftCard' | translate }}"
                      aria-describedby="giftCardError"
                      data-test-id="gift-card-input"
                      type="text"
                      inputmode="text"
                      class="form-control"
                      [disabled]="isLoading || isApplyingGiftCard"
                      [(ngModel)]="giftCardReferenceCode"
                      [attr.aria-invalid]="giftCardAttemptState == 'invalid'"
                    />
                    <button
                      type="button"
                      class="btn btn-white"
                      (click)="attemptGiftcard()"
                      [disabled]="isLoading || isApplyingGiftCard"
                      data-test-id="gift-card-button-add"
                    >
                      {{ 'general.add' | translate }}
                    </button>
                  </div>

                  <p
                    class="invalid-feedback"
                    aria-atomic="true"
                    id="giftCardError"
                    role="alert"
                    *ngIf="giftCardAttemptState == 'invalid'"
                  >
                    {{ 'paymentModule.giftCardSubtext' | translate }}
                  </p>
                  <p
                    class="alert alert-success"
                    aria-atomic="true"
                    id="giftCardSuccess"
                    role="alert"
                    *ngIf="giftCardAttemptState == 'success'"
                  >
                    {{ 'alerts.success' | translate }}
                  </p>
                </div>
              </div>
            </fieldset>
            <div
              class="spinner-border"
              role="status"
              *ngIf="isLoading"
              data-test-id="sale-checkout-loading"
              attr.aria-label="{{ 'wcag.loading' | translate }}"
            >
            </div>

            <div
              *ngIf="
                legacyStoredDirectDebitStoredPayMethod &&
                futurePaymentsBilledByDirectDebit
              "
              class="d-flex mb-md-1"
            >
              <p
                >{{ 'paymentModule.futurePaymentsWillBeBilleOn' | translate }}
                {{ legacyStoredDirectDebitStoredPayMethod.bankAccount }}</p
              >
            </div>

            <!-- CANCEL - CONFIRM BUTTONS -->
            <div class="border-top pt-sm-3 fixed-mobile">
              <div class="d-flex mb-md-1 justify-content-between">
                <button
                  type="button"
                  class="btn btn-white"
                  data-test-id="cancel-sale-button"
                  (click)="onClickCancel()"
                  [disabled]="isLoading"
                >
                  {{ 'general.cancel' | translate }}
                </button>

                <button
                  type="button"
                  [disabled]="
                    (shouldCreateStoredPayMethod &&
                      !isStoredPayMethodCreationSideEffectOfPayment) ||
                    checkoutStage !== 'unstarted' ||
                    (pendingSaleHasExpired$ | async)
                  "
                  class="btn btn-primary px-5"
                  (click)="onClickPay(sale)"
                  data-test-id="confirm-sale-button"
                >
                  {{ 'general.confirm' | translate }}
                  <span
                    class="spinner-border spinner-border-sm ms-2"
                    role="status"
                    *ngIf="checkoutStage === 'inPayment'"
                    attr.aria-label="{{ 'wcag.loading' | translate }}"
                  >
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div
            class="card-body"
            *ngIf="sale?.statusCode === StatusCode.CANCELLED"
          >
            <h2 class="h4">
              {{ 'saleModule.orderCanceled' | translate }}
            </h2>
            <div class="row align-items-center p-3">
              <div class="col-9">
                {{ 'saleModule.orderCanceledSubtitle' | translate }}
              </div>
              <div class="col-3">
                <figure class="max-w-10rem mx-auto">
                  <img
                    class="img-fluid"
                    src="../assets/svg/illustrations/payment-card.svg"
                    alt="{{ 'wcag.paymentCard' | translate }}"
                  />
                </figure>
              </div>
            </div>

            <button
              *ngIf="bookingModuleConfig.isActive"
              [routerLink]="getLandingPageRedirect()"
              type="button"
              class="btn btn-primary"
            >
              {{ 'productModule.schedule' | translate }}
            </button>

            <button
              *ngIf="!bookingModuleConfig.isActive && shopModuleConfig.isActive"
              [routerLink]="AppRoutesNS.Shop.SHOP"
              type="button"
              class="btn btn-primary"
            >
              {{ 'shopModule.shop' | translate }}
            </button>
          </div>
        </div>
      </section>
    </div>

    <div
      class="col-12 col-md-6 col-lg-5 px-0 px-md-3"
      *ngIf="sale?.statusCode === StatusCode.DONE"
    >
      <section class="card">
        <div class="card-header">
          <h3 class="card-title" data-test-id="sale-already-completed-title">
            {{ 'saleModule.orderAlreadyCompleted' | translate }}
          </h3>
        </div>

        <div class="card-body text-center">
          <div class="mb-3">
            <button
              *ngIf="
                !sale.isCreditOfSaleId &&
                (saleService.isTicketSale$(sale) | async) &&
                showDownloadTicketsButton &&
                activeTicketingBlockModule
              "
              data-test-id="sale-checkout-download-tickets-button"
              [disabled]="!saleDocuments?.length"
              type="button"
              class="btn btn-soft-primary"
              (click)="onClickDownloadTicket(saleDocuments)"
            >
              {{ 'general.downloadTicket' | translate }}
            </button>
          </div>

          <button
            [routerLink]="getLandingPageRedirect()"
            type="button"
            class="btn btn-primary"
          >
            {{ 'productModule.schedule' | translate }}
          </button>
        </div>
      </section>
    </div>
  </div>
</div>
